import React from "react";

import styles from "./Section6.module.scss";

export const Section6 = function () {
  return (
    <section id="conveners-section" className={`${styles.section6Wrapper} cc--component-container`}>
      <h3>YOUR FACULTY DIRECTOR</h3>
      <div className={styles.section6Container}>
        <div className={styles.section6Content}>
          <div className={styles.image} />
          <div className={styles.name}>
            <p>Regina Barzilay</p>
            <p>
              <i>
                School of Engineering Distinguished Professor for AI and Health; AI Faculty Lead, Jameel Clinic
              </i>
            </p>
          </div>
          <div className={styles.summary}>
            <p>
              Barzilay is a member of the Computer Science and Artificial Intelligence Laboratory at the Massachusetts Institute of Technology (MIT). She is an AI faculty lead for Jameel Clinic, an MIT center for Machine Learning in Health. Her research interests are in machine learning models for molecular modeling with applications to drug discovery and clinical AI. She also works in natural language processing. She is a recipient of various awards and received her PhD in computer science from Columbia University. She also spent a year as a postdoc at Cornell University.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
